import { createBrowserRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';

import routerWindow from './components/sharedComponents/CustomPrompt/routerWindow';
import { ErrorBoundary } from './errorBoundary';
import useInitApp from './hooks/useInitApp';
import { createRoute } from './routes/routes';

const router = createBrowserRouter(createRoute(), { window: routerWindow });

export const App = () => {
  useInitApp();

  return (
    <ErrorBoundary>
      <RouterProvider router={router} />
    </ErrorBoundary>
  );
};
